import { motion } from "framer-motion";
import sanawarLogo from "../../img/Parallax/sanawar-logo.png";

export default function RegistrationClosed() {
  return (
    <div className="w-full flex flex-col justify-center items-center text-center p-8 md:p-12 bg-white-1/90 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200">
      {/* Logo */}
      <div className="flex justify-center mb-5">
        <img
          src={sanawarLogo}
          alt="Sanawar Logo"
          className="h-20 w-auto md:h-24"
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-semibold text-gray-800 flex items-center justify-center gap-2 mb-4">
        <span>Registrations Are Now Closed</span> <span>🚫</span>
      </h1>

      {/* Subtitle */}
      <p className="text-gray-600 text-base md:text-lg max-w-md leading-relaxed">
        Thank you for your overwhelming response! All available slots for the
        event have been filled. We’re excited to see everyone at the race.{" "}
        <span className="text-xl">🏁</span>
      </p>

      {/* Button */}
      <motion.a
        href="/"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        className="mt-6 px-6 py-3 bg-blue text-white-1 rounded-full font-medium hover:bg-blue-hover transition-colors duration-200"
      >
        Go Back Home
      </motion.a>
    </div>
  );
}
